import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ResponseDto } from '../response/response.interface';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private http: HttpClient) { }

  public  isAuthenticated() {
    return  this.http.get<ResponseDto>('api/Account/IsAuthenticated');
  }
}
